import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SVGIcon from '../SVGIcon/SVGIcon';
import { FaApple, FaGooglePlay } from 'react-icons/fa';
import './Footer.css';
import { API_BASE_URL } from '../../config';

export default function Footer({
  triggerNotification = () => { },
  showNewsletter = true,
  onNavigate
}) {
  const navigate = useNavigate();
  const [newsletterEmail, setNewsletterEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleNewsletterSubmit = async (e) => {
    if (!newsletterEmail.trim()) {
      triggerNotification("Please enter a valid email address.");
      return;
    }

    try {
      const response = await fetch(`${API_BASE_URL}/orders/newsletter-subscribe`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: newsletterEmail })
      });
      const data = await response.json();
      if (response.ok && data.success) {
        setSubscribed(true);
        triggerNotification("Thank you for subscribing to our newsletter!");
        setNewsletterEmail('');
        setTimeout(() => setSubscribed(false), 5000);
      } else {
        triggerNotification(data.message || "Failed to subscribe. Please try again.");
      }
    } catch (err) {
      triggerNotification("Network error. Failed to connect to server.");
    }
  };

  return (
    <div className="footer-wrapper">
      {/* Subscribe Newsletter Section */}
      {showNewsletter && (
        <section className="newsletter-section">
          <div className="container newsletter-grid">
            <div className="newsletter-text-block">
              <h2>Subscribe to our Newsletter</h2>
              <p>Get expert advice on crop care, fertilizer usage, seasonal farming practices, and special product updates delivered directly to your inbox.</p>
            </div>
            <form className="newsletter-form-block" onSubmit={(e) => { e.preventDefault(); handleNewsletterSubmit(e); }}>
              <input
                type="email"
                placeholder="Your email address"
                required
                value={newsletterEmail}
                onChange={(e) => setNewsletterEmail(e.target.value)}
              />
              <button type="submit" className="btn btn-primary subscribe-btn">
                {subscribed ? 'Subscribed!' : 'Subscribe'}
              </button>
            </form>
            <div className="newsletter-socials">
              <a
                href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => {
                  navigator.clipboard.writeText(window.location.href);
                  triggerNotification("Page link copied! Opening Facebook...");
                }}
                title="Share on Facebook"
              >
                <SVGIcon name="facebook" size={20} className="social-icon" />
              </a>
              <a
                href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(window.location.href)}`}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => {
                  navigator.clipboard.writeText(window.location.href);
                  triggerNotification("Page link copied! Opening Twitter...");
                }}
                title="Share on Twitter"
              >
                <SVGIcon name="twitter" size={20} className="social-icon" />
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => {
                  navigator.clipboard.writeText(window.location.href);
                  triggerNotification("Page link copied! Opening Instagram...");
                }}
                title="Share on Instagram"
              >
                <SVGIcon name="instagram" size={20} className="social-icon" />
              </a>
            </div>
          </div>
        </section>
      )}

      {/* Main Footer */}
      <footer className="main-footer" id="contact">
        <div className="container footer-grid">
          {/* Col 1 */}
          <div className="footer-brand-col">
            <div className="logo-section" onClick={() => window.location.href = '/'}>
              <img src="/logo/Orbifert Logo.png" alt="ORBIFERT Logo" className="logo-full-img" />
              <div className="logo-brand-text">
                <span className="brand-name-top">ORBIFERT</span>
                <span className="brand-name-sub">ORGANIC PVT. LTD</span>
                <span className="brand-name-tagline">Reviving Soil, <span className="tagline-green">Rewarding Farmers</span></span>
              </div>
            </div>
            <p className="brand-pitch">
              Empowering farmers with sustainable crop nutrition solutions for healthier soil and higher yields.     </p>
            <div className="contact-links-list">
              <span className="contact-item font-num">+917228064418</span>
              <span className="contact-or">or</span>
              <span className="contact-item">orbifertorganic@gmail.com</span>
            </div>
          </div>

          {/* Col 2 */}
          <div className="footer-links-col">
            <h3>Quick Links</h3>
            <ul>
              <li><a href="/about" onClick={(e) => { e.preventDefault(); navigate('/about'); window.scrollTo(0, 0); }}>About Us</a></li>
              <li><a href="/shop" onClick={(e) => { e.preventDefault(); navigate('/shop'); window.scrollTo(0, 0); }}>Products Catalog</a></li>
              <li><a href="/knowledge-hub" onClick={(e) => { e.preventDefault(); navigate('/knowledge-hub'); window.scrollTo(0, 0); }}>Knowledge Hub</a></li>
              <li><a href="/contact" onClick={(e) => { e.preventDefault(); navigate('/contact'); window.scrollTo(0, 0); }}>Contact Us</a></li>
            </ul>
          </div>

          {/* Col 3 */}
          <div className="footer-links-col">
            <h3>Featured Products</h3>
            <ul>
              <li><a href="/product/bio-orbi-super-novel" onClick={(e) => { e.preventDefault(); navigate('/product/bio-orbi-super-novel'); window.scrollTo(0, 0); }}>BIO-ORBI Super Novel</a></li>
              <li><a href="/product/bio-orbi-super-plus" onClick={(e) => { e.preventDefault(); navigate('/product/bio-orbi-super-plus'); window.scrollTo(0, 0); }}>BIO ORBI Super Plus</a></li>
              <li><a href="/product/bio-orbi-super-prime" onClick={(e) => { e.preventDefault(); navigate('/product/bio-orbi-super-prime'); window.scrollTo(0, 0); }}>BIO ORBI Super Prime</a></li>
              <li><a href="/product/bio-orbi-super" onClick={(e) => { e.preventDefault(); navigate('/product/bio-orbi-super'); window.scrollTo(0, 0); }}>BIO ORBI Super</a></li>
            </ul>
          </div>

          {/* Col 4 */}
          <div className="footer-links-col">
            <h3>Information</h3>
            <ul>
              <li><a href="/help-center" onClick={(e) => { e.preventDefault(); navigate('/help-center'); window.scrollTo(0, 0); }}>Help Center / FAQs</a></li>
              <li><a href="#terms" onClick={(e) => { e.preventDefault(); triggerNotification("Opening Terms & Conditions..."); }}>Terms & Conditions</a></li>
              <li><a href="#privacy" onClick={(e) => { e.preventDefault(); triggerNotification("Opening Privacy Policy..."); }}>Privacy Policy</a></li>
            </ul>
          </div>

          {/* Col 5 */}
          <div className="footer-app-col">
            <h3>Mobile App - Launching Soon</h3>
            <div className="app-download-badges">
              <a href="/ios-app" className="download-btn flex-center" onClick={(e) => { e.preventDefault(); navigate('/ios-app'); window.scrollTo(0, 0); }}>
                <FaApple className="badge-logo-svg font-apple" />
                <div className="badge-text">
                  <span className="btn-sub">Download on the</span>
                  <span className="btn-main">App Store</span>
                </div>
              </a>
              <a href="/apk-app" className="download-btn flex-center" onClick={(e) => { e.preventDefault(); navigate('/apk-app'); window.scrollTo(0, 0); }}>
                <FaGooglePlay className="badge-logo-svg font-google" />
                <div className="badge-text">
                  <span className="btn-sub">Download on the</span>
                  <span className="btn-main">Google Play</span>
                </div>
              </a>
            </div>
          </div>
        </div>

        {/* Footer Bottom copyright */}
        <div className="footer-bottom-bar">
          <div className="container bottom-content">
            <p className="copyright-text">Orbifert Organic © 2026. All Rights Reserved. || Design & Developed by <a href="https://www.creativevasishtha.com" target="_blank" rel="noopener noreferrer"><b>Creative Vasishtha</b></a></p>
            {/* Payment gateways removed for catalog-only website */}
          </div>
        </div>
      </footer>
    </div>
  );
}
